import { FC } from "react";
import classNames from "classnames";

import Skeleton from "../../../../components/Skeleton/Skeleton";

import styles from "./SourceDetailLinksTableSkeleton.module.css";

const TABLE_ROWS = 8;

const SourceDetailLinksTableSkeleton: FC<{ className?: string }> = ({
  className,
}) => (
  <div
    className={classNames(styles["source_detail_links_skeleton"], className)}
    aria-busy="true"
    aria-label="Loading links"
  >
    <table className={styles["source_detail_links_skeleton__table"]}>
      <thead className={styles["source_detail_links_skeleton__thead"]}>
        <tr>
          <th><Skeleton height={16} width={20} variant="text" /></th>
          <th><Skeleton height={16} width={48} variant="text" /></th>
          <th><Skeleton height={16} width={72} variant="text" /></th>
          <th><Skeleton height={16} width={40} variant="text" /></th>
          <th><Skeleton height={16} width={64} variant="text" /></th>
        </tr>
      </thead>
      <tbody className={styles["source_detail_links_skeleton__body"]}>
        {Array.from({ length: TABLE_ROWS }).map((_, rowIndex) => (
          <tr key={rowIndex}>
            <td><Skeleton height={20} width={20} variant="text" /></td>
            <td>
              <div className={styles["source_detail_links_skeleton__source"]}>
                <Skeleton
                  width={28}
                  height={28}
                  className={styles["source_detail_links_skeleton__logo"]}
                />
                <Skeleton height={20} width={180} variant="text" />
              </div>
            </td>
            <td><Skeleton height={20} width={32} variant="text" /></td>
            <td><Skeleton height={20} width={24} variant="text" /></td>
            <td><Skeleton height={20} width={32} variant="text" /></td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SourceDetailLinksTableSkeleton;
